import * as React from 'react';

import { observer } from 'mobx-react';

import { classes } from '~utils/Classes';
import { sidebarLastSection } from '~utils/loadOnDemand';

import { sidebarSections } from '../sections';
import { IShowcaseHeader, IShowcaseProps } from './IShowcase';
import { ShowcaseSliders } from './ShowcaseSliders';
import { ShowcaseHeaderLink, ShowcaseWrapper } from './ShowcaseWrapper';

const showcaseHeaderClass = classes('account-showcase-header');
const showcaseHeaderLinkClass = classes('account-showcase-header-link');
const ShowcaseHeader = observer(function ShowcaseHeader({ header, infoLink }: IShowcaseHeader) {
    return (
        <>
            <span className={showcaseHeaderClass}>{header}</span>
            {infoLink?.url && (
                <ShowcaseHeaderLink className={showcaseHeaderLinkClass} href={infoLink.url}>
                    {infoLink.label}
                </ShowcaseHeaderLink>
            )}
        </>
    );
});

export const TEST_ID_SHOWCASE = 'account-showcase';
const showcaseClass = classes('account-showcase');

export const Showcase = observer(function Showcase(props: IShowcaseProps) {
    const {
        brandServices: { header, infoLink, list = [] },
        onClick
    } = props;

    const isLastSection = sidebarLastSection === sidebarSections.showcase;

    return (
        <ShowcaseWrapper
            className={showcaseClass}
            data-test-id={TEST_ID_SHOWCASE}
            isLastSection={isLastSection}
        >
            <ShowcaseHeader header={header} infoLink={infoLink} />
            {list.length > 0 && <ShowcaseSliders onClick={onClick} list={list} />}
        </ShowcaseWrapper>
    );
});
